import DateSelector from '@zet/integrated-journeys/modules/common/dateSelector'

import { MobileInput, SelectDropDown, TextInput, Toggle } from '../components'

export const formComponentMap = {
  text: {
    component: TextInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      code: 'name',
      isRequired: 'isRequired',
      infoMsg: 'infoMsg',
      style: 'style',
      isEditable: 'isEditable',
      maxLength: 'maxLength',
      autoCapitalize: 'autoCapitalize',
    },
    propValues: {
      type: 'text',
      noIconPadding: true,
    },
  },
  phoneNumber: {
    component: MobileInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      config: 'config',
    },
    propValues: {
      type: 'text',
      noIconPadding: true,
      countryCode: '+91',
    },
  },
  number: {
    component: TextInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      code: 'name',
      isRequired: 'isRequired',
      infoMsg: 'infoMsg',
      isEditable: 'isEditable',
      maxLength: 'maxLength',
      iconLeft: 'iconLeft',
    },
    propValues: {
      type: 'number',
      keyboardType: 'number-pad',
    },
  },
  toggle: {
    component: Toggle,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      name: 'name',
      fieldOptions: 'fieldOptions',
      toggleType: 'toggleType',
    },
  },
  dropDown: {
    component: SelectDropDown,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      options: 'fieldOptions',
      dropOptions: 'dropOptions',
      code: 'name',
      infoMsg: 'infoMsg',
    },
  },
  date: {
    component: DateSelector,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      label: 'label',
      code: 'name',
      isRequired: 'isRequired',
      value: 'value',
      infoMsg: 'infoMsg',
    },
  },
}
